import Index from '../components/ExpositionOrder/Index';

let routes = {
    path: '/expositionOrder',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/expositionOrder',
            component: Index
        }
    ]
};

export default routes;


// WEBPACK FOOTER //
// ./src/router/expositionOrder.js